// eslint-disable-next-line import/no-unresolved
import { create, MathJsStatic, roundDependencies } from 'mathjs/number';

export const { round } = create(roundDependencies) as Partial<MathJsStatic> & Pick<MathJsStatic, 'round'>;
